import { getLocale } from "./index.js";

// Exact-match French -> {en} lookup for the short phrases generated by
// agents.js (workflow step labels/details, table row labels, audit log
// action/detail strings, citation fallback labels). Anything not listed here
// falls back to the original French text, so a missing entry degrades
// gracefully instead of breaking.
const PHRASES = {
  "Actualise le narratif d'activite": { en: "Updates the business narrative" },
  "Analyse marche et plus-values": { en: "Analyzes market and capital gains" },
  "Appetence, cartographie, scenarios": { en: "Risk appetite, risk map, scenarios" },
  "Architecte": { en: "Architect" },
  "Architecte section": { en: "Section architect" },
  "Auditeur Art. 295": { en: "Art. 295 auditor" },
  "Avis provisions, souscription, reassurance": { en: "Opinion on provisions, underwriting, reinsurance" },
  "Best Estimate brut": { en: "Gross Best Estimate" },
  "Best Estimate, marge de risque, reassurance": { en: "Best Estimate, risk margin, reinsurance" },
  "Changements de structure": { en: "Structural changes" },
  "Charges autres activites": { en: "Other activities expenses" },
  "Chiffre d'affaires assurance": { en: "Insurance revenue" },
  "Collecte les sources": { en: "Collects the sources" },
  "Commentaire de materialite": { en: "Materiality commentary" },
  "Comparateur N-1": { en: "N-1 comparator" },
  "Comparateur methodes": { en: "Method comparator" },
  "Composition des fonds propres": { en: "Own-funds composition" },
  "Confirme la non-applicabilite": { en: "Confirms non-applicability" },
  "Consolidateur A-E": { en: "A-E consolidator" },
  "Constat de respect": { en: "Compliance statement" },
  "Contrats actifs": { en: "Active contracts" },
  "Contribution au SCR": { en: "Contribution to the SCR" },
  "Controle actuariel": { en: "Actuarial check" },
  "Controle clauses": { en: "Clause review" },
  "Controle eligibilite": { en: "Eligibility check" },
  "Controle honorabilite": { en: "Fit-and-proper check" },
  "Controle le style": { en: "Checks the style" },
  "Controle reporting reglementaire": { en: "Regulatory reporting check" },
  "Controle ventilation par categorie d'actif": { en: "Checks the breakdown by asset category" },
  "Couverture MCR": { en: "MCR coverage" },
  "Couverture SCR et MCR": { en: "SCR and MCR coverage" },
  "Couverture sorties 3 mois": { en: "3-month outflow coverage" },
  "Creances d'assurance": { en: "Insurance receivables" },
  "Detecte les changements d'activite": { en: "Detects business changes" },
  "Dettes fiscales et sociales": { en: "Tax and social liabilities" },
  "Dettes fournisseurs": { en: "Trade payables" },
  "Direction financiere": { en: "Finance department" },
  "Dirigeants effectifs": { en: "Effective managers" },
  "Dirigeants, fonctions cles, revues": { en: "Managers, key functions, reviews" },
  "Dispositif de gestion des risques": { en: "Risk management framework" },
  "Episodes de non-respect MCR": { en: "MCR breach episodes" },
  "Episodes de non-respect SCR": { en: "SCR breach episodes" },
  "Equipe capital": { en: "Capital team" },
  "Escalade juridique / SG": { en: "Legal / general secretariat escalation" },
  "Evolution, attenuation, sensibilites": { en: "Trend, mitigation, sensitivities" },
  "Exigence de capital": { en: "Capital requirement" },
  "Explique les variations via KB et contributeur": { en: "Explains variations via the KB and a contributor" },
  "Exposition bancaire notee A ou plus": { en: "Bank exposure rated A or above" },
  "Extracteur": { en: "Extractor" },
  "Extracteur ORSA": { en: "ORSA extractor" },
  "Extracteur QRT S.05.01": { en: "QRT S.05.01 extractor" },
  "Extracteur QRT S.23.01": { en: "QRT S.23.01 extractor" },
  "Extracteur RH": { en: "HR extractor" },
  "Extracteur SCR/MCR": { en: "SCR/MCR extractor" },
  "Extracteur activite": { en: "Business extractor" },
  "Extracteur audit interne": { en: "Internal audit extractor" },
  "Extracteur autres activites": { en: "Other activities extractor" },
  "Extracteur comptes": { en: "Accounts extractor" },
  "Extracteur controles": { en: "Controls extractor" },
  "Extracteur fonction actuarielle": { en: "Actuarial function extractor" },
  "Extracteur gouvernance": { en: "Governance extractor" },
  "Extracteur provisionnement": { en: "Reserving extractor" },
  "Extracteur registre fournisseurs": { en: "Vendor register extractor" },
  "Extracteur valorisation": { en: "Valuation extractor" },
  "Faits saillants et decisions": { en: "Highlights and decisions" },
  "Fonctions cles": { en: "Key functions" },
  "Fonds propres disponibles": { en: "Available own funds" },
  "Fonds propres eligibles Tier 1": { en: "Eligible Tier 1 own funds" },
  "Fonds propres eligibles Tier 2": { en: "Eligible Tier 2 own funds" },
  "Fonds propres eligibles par Tier": { en: "Eligible own funds by tier" },
  "Harmonise avec le SFCR N-1": { en: "Aligns with the N-1 SFCR" },
  "Hypotheses et methodes": { en: "Assumptions and methods" },
  "Identifie les changements vs N-1": { en: "Identifies changes vs. N-1" },
  "Identite, portefeuille, perimetre": { en: "Identity, portfolio, scope" },
  "Incidents operationnels majeurs": { en: "Major operational incidents" },
  "Interprete module SCR": { en: "SCR module interpreter" },
  "Interprete placements": { en: "Investment interpreter" },
  "Interprete risques": { en: "Risk interpreter" },
  "Interprete sinistralite": { en: "Claims experience interpreter" },
  "Art. 295 - Resultats des investissements par categorie d'actif": { en: "Art. 295 - Investment performance by asset category" },
  "Routeur d'escalade": { en: "Escalation Router" },
  "Le bloc A.3 est produit, mais l'auditeur demande une piece de travail complementaire sur la ventilation obligations / actions / immobilier / tresorerie.": {
    en: "Block A.3 has been produced, but the auditor is requesting a supporting document on the breakdown between bonds / equities / real estate / cash.",
  },
  "Lit les blocs valides et les faits marquants": { en: "Reads the approved blocks and key events" },
  "Manager rapport": { en: "Report manager" },
  "Manager": { en: "Manager" },
  "Marge de risque": { en: "Risk margin" },
  "Mention de non-applicabilite": { en: "Not-applicable statement" },
  "Mention de respect du capital": { en: "Capital compliance statement" },
  "Methodes et bases prudentielles": { en: "Methods and prudential bases" },
  "ORSA, RSR et cartographie des risques": { en: "ORSA, RSR and risk map" },
  "Organigramme, comites, fonctions cles": { en: "Org chart, committees, key functions" },
  "Part des reassureurs": { en: "Reinsurers' share" },
  "Pieces competence et honorabilite": { en: "Fit-and-proper documents" },
  "Placements": { en: "Investments" },
  "Plan d'audit, missions, recommandations": { en: "Audit plan, engagements, recommendations" },
  "Plan de controle et anomalies": { en: "Control plan and anomalies" },
  "Plans d'action clotures": { en: "Closed action plans" },
  "Plans de controle actifs": { en: "Active control plans" },
  "Prestataires critiques et contrats": { en: "Critical vendors and contracts" },
  "Prestataires critiques suivis": { en: "Monitored critical vendors" },
  "Primes acquises": { en: "Earned premiums" },
  "Primes, sinistres, frais, ratios": { en: "Premiums, claims, expenses, ratios" },
  "Produit la mention courte": { en: "Produces the short statement" },
  "Produit la synthese publique": { en: "Produces the public summary" },
  "Produit le texte": { en: "Produces the text" },
  "Produit le texte introductif de section": { en: "Produces the section's introductory text" },
  "Produits accessoires": { en: "Ancillary income" },
  "Produits et charges accessoires": { en: "Ancillary income and expenses" },
  "Produits, charges et resultat financier": { en: "Income, expenses and financial result" },
  "QRT capital et ORSA": { en: "Capital QRT and ORSA" },
  "Qualite des fonds propres": { en: "Own-funds quality" },
  "RSR, comptes et dossier actuariel": { en: "RSR, accounts and actuarial file" },
  "Ratio couverture SCR": { en: "SCR coverage ratio" },
  "Ratio de solvabilite": { en: "Solvency ratio" },
  "Ratio frais / primes": { en: "Expense / premium ratio" },
  "Recherche d'evenements SCR/MCR": { en: "Search for SCR/MCR events" },
  "Redacteur": { en: "Writer" },
  "Redacteur S2": { en: "Solvency II writer" },
  "Redacteur SGR": { en: "Risk management writer" },
  "Redacteur actuariel": { en: "Actuarial writer" },
  "Redacteur audit interne": { en: "Internal audit writer" },
  "Redacteur capital": { en: "Capital writer" },
  "Redacteur chapeau": { en: "Section-intro writer" },
  "Redacteur constat": { en: "Findings writer" },
  "Redacteur controle interne": { en: "Internal control writer" },
  "Redacteur gouvernance": { en: "Governance writer" },
  "Redacteur mention": { en: "Note writer" },
  "Redacteur provisions": { en: "Provisions writer" },
  "Redacteur risque": { en: "Risk writer" },
  "Redacteur solvabilite": { en: "Solvency writer" },
  "Redacteur sous-traitance": { en: "Outsourcing writer" },
  "Redacteur synthese": { en: "Summary writer" },
  "Responsable audit interne": { en: "Internal audit owner" },
  "Responsable controle interne": { en: "Internal control owner" },
  "Responsable gestion des risques": { en: "Risk management owner" },
  "Restitution SFCR": { en: "SFCR write-up" },
  "Resultat financier": { en: "Financial result" },
  "Revue de coherence section": { en: "Section consistency review" },
  "Revue finale du bloc": { en: "Final review of the block" },
  "Revues honorabilite realisees": { en: "Fit-and-proper reviews completed" },
  "Routeur si nouveau prestataire": { en: "Router if a new vendor" },
  "SCR defaut": { en: "Default SCR" },
  "SCR marche": { en: "Market SCR" },
  "SCR souscription non-vie": { en: "Non-life underwriting SCR" },
  "Secretariat general": { en: "General secretariat" },
  "Sensibilite taux": { en: "Interest-rate sensitivity" },
  "Sign-off Direction": { en: "Management sign-off" },
  "Sign-off actuariel": { en: "Actuarial sign-off" },
  "Sign-off competence et honorabilite": { en: "Fit-and-proper sign-off" },
  "Sinistralite nette": { en: "Net claims ratio" },
  "Societaires couverts": { en: "Covered members" },
  "Structure le bloc": { en: "Structures the block" },
  "Synthese du dispositif": { en: "Framework summary" },
  "Taux de retention": { en: "Retention rate" },
  "Texte chiffres + interpretation": { en: "Figures + commentary text" },
  "Texte et structure de gouvernance": { en: "Governance text and structure" },
  "Texte fonction actuarielle": { en: "Actuarial function text" },
  "Texte par module de risque": { en: "Text per risk module" },
  "Texte registre + controle": { en: "Register + control text" },
  "Tresorerie disponible": { en: "Available cash" },
  "Tresorerie et equivalents": { en: "Cash and equivalents" },
  "Validation 1-clic": { en: "1-click approval" },
  "Validation CRO": { en: "CRO approval" },
  "Validation RH / SG": { en: "HR / general secretariat approval" },
  "Validation SG": { en: "General secretariat approval" },
  "Validation audit interne": { en: "Internal audit approval" },
  "Validation chiffres": { en: "Figures approval" },
  "Validation controle interne": { en: "Internal control approval" },
  "Validation finale": { en: "Final approval" },
  "Validation finance": { en: "Finance approval" },
  "Validation fonction actuarielle": { en: "Actuarial function approval" },
  "Validation manager": { en: "Manager approval" },
  "Validation manager puis DG": { en: "Manager then CEO approval" },
  "Validation pilotage SCR": { en: "SCR steering approval" },
  "Valorisation des provisions techniques": { en: "Technical provisions valuation" },
  "Verificateur d'absence": { en: "Absence verifier" },
  "Verificateur de seuils": { en: "Threshold verifier" },
  "Verificateur non-respect": { en: "Non-compliance verifier" },
  "Verification sous-traitance importante": { en: "Material outsourcing check" },
  "Resume les blocs de la section Activite et resultats": { en: "Summarizes the Business and performance section's blocks" },
  "Resume les blocs de la section Systeme de gouvernance": { en: "Summarizes the System of governance section's blocks" },
  "Resume les blocs de la section Profil de risque": { en: "Summarizes the Risk profile section's blocks" },
  "Resume les blocs de la section Valorisation Solvabilite 2": { en: "Summarizes the Solvency II valuation section's blocks" },
  "Resume les blocs de la section Gestion du capital": { en: "Summarizes the Capital management section's blocks" },

  // Table row labels as they appear in the captured report-state.json data
  // (accented), distinct dict entries from the agents.js-generated ones above.
  "Primes émises (brut)": { en: "Gross premiums written" },
  "Primes acquises (brut)": { en: "Gross earned premiums" },
  "Charge de sinistres (net)": { en: "Net claims charge" },
  "Frais généraux": { en: "General expenses" },
  "Ratio S/P acquises": { en: "Claims / earned premiums ratio" },
  "Ratio Frais/primes acquises": { en: "Expenses / earned premiums ratio" },
  "Résultat financier": { en: "Financial result" },
  "Produits de placements": { en: "Investment income" },
  "Charges de placements": { en: "Investment expenses" },
  "Plus-values fonds d'investissement": { en: "Gains on investment funds" },
  "La reponse contributeur a ete integree a la redaction:": { en: "The contributor's reply has been incorporated into the drafting:" },

  // Audit trail (addAudit action/detail literals)
  "Chaine d'agents lancee": { en: "Agent chain started" },
  "Production terminee": { en: "Production complete" },
  "Texte, tableau et citations generes selon le theme du bloc.": { en: "Text, table and citations generated based on the block's theme." },
  "Audit relance": { en: "Audit rerun" },
  "Les criteres mock sont maintenant OK.": { en: "The mock criteria are now OK." },
  "Demande contributeur envoyée": { en: "Contributor request sent" },
  "Reponse contributeur recue": { en: "Contributor reply received" },
  "Réponse simulée en attente de validation.": { en: "Simulated reply awaiting approval." },
  "Réponse contributeur validée": { en: "Contributor reply approved" },
  "La réponse est utilisée directement comme texte du bloc.": { en: "The reply is used directly as the block's text." },
  "Texte modifie": { en: "Text edited" },
  "Modification locale du texte produit.": { en: "Local edit of the produced text." },
  "Cellule tableau modifiee": { en: "Table cell edited" },
  "Bloc valide": { en: "Block approved" },
  "Validation manager simulee.": { en: "Simulated manager approval." },

  // Actor prefixes / generic role words reused in dynamic templates
  "Agent": { en: "Agent" },
  "Humain": { en: "Human" },
  "Contributeur": { en: "Contributor" },
  "Non assigné": { en: "Unassigned" },
  "Agent: Manager": { en: "Agent: Manager" },
  "Agent: Style Keeper": { en: "Agent: Style Keeper" },
  "Agent: Auditeur Reglementaire": { en: "Agent: Regulatory Auditor" },
  "Agent: Routeur d'escalade": { en: "Agent: Escalation Router" },
  "Humain: Romain Nobis": { en: "Human: Romain Nobis" },
  "Plan global valide": { en: "Global plan approved" },
  "Le rapport est initialise vide pour la production bloc par bloc.": { en: "The report is initialized empty for block-by-block production." },

  // Citation fallback labels (buildCitations)
  "Source chiffre": { en: "Sourced figure" },
  "Extrait KB": { en: "KB excerpt" },
  "Contributeur RACI": { en: "RACI contributor" },
  "source": { en: "source" },
  "kb": { en: "kb" },
  "RACI": { en: "RACI" },
  "Referentiel reglementaire": { en: "Regulatory framework" },
  "Exigence applicable au bloc.": { en: "Requirement applicable to this block." },

  // Contributor reply templates (static ones)
  "Aucun sinistre grave superieur a 1 M€ n'a ete recense sur l'exercice. La variation provient principalement d'un effet de base et d'une meilleure retention.": {
    en: "No claim above €1M was recorded during the year. The variation mainly comes from a base effect and better retention.",
  },
  "La hausse du resultat financier s'explique par des plus-values realisees sur fonds d'investissement et par la non-recurrence de moins-values observees en N-1.": {
    en: "The increase in financial result is explained by realized gains on investment funds and by the non-recurrence of losses observed in N-1.",
  },
  "Le nouveau prestataire mobilite est dans le perimetre depuis septembre 2025. Le registre et les controles doivent etre mis a jour avant publication.": {
    en: "The new mobility vendor has been in scope since September 2025. The register and controls must be updated before publication.",
  },
  "Les hypotheses de provisionnement restent coherentes avec la note Q4. La marge de risque diminue sous l'effet de la courbe de taux et du profil de liquidation.": {
    en: "The reserving assumptions remain consistent with the Q4 note. The risk margin decreases due to the rate curve and the settlement profile.",
  },
  "Aucun non-respect SCR ou MCR n'a ete observe. La couverture reste superieure aux seuils internes et reglementaires.": {
    en: "No SCR or MCR breach was observed. Coverage remains above internal and regulatory thresholds.",
  },
};

export function tr(fr) {
  if (!fr) return fr;
  if (getLocale() === "fr") return fr;
  const entry = PHRASES[fr];
  if (!entry) return fr;
  return entry[getLocale()] || fr;
}
